import { FC } from "react";

interface WashingHandIconSVGProps {
    className?: string;
}

const WashingHandIconSVG: FC<WashingHandIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="64"
            height="65"
            viewBox="0 0 64 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.3334 40.4997H34.6667C36.0812 40.4997 37.4377 39.9378 38.4379 38.9376C39.4381 37.9374 40 36.5808 40 35.1663C40 33.7519 39.4381 32.3953 38.4379 31.3951C37.4377 30.3949 36.0812 29.833 34.6667 29.833H26.6667C25.0667 29.833 23.7334 30.3663 22.9334 31.433L8.00004 45.833M18.6667 56.4997L22.9334 52.7664C23.7334 51.6997 25.0667 51.1663 26.6667 51.1663H37.3334C40.2667 51.1663 42.9334 50.0997 44.8 47.9663L57.0667 36.233C58.0957 35.2606 58.6963 33.9191 58.7363 32.5039C58.7763 31.0886 58.2525 29.7154 57.28 28.6863C56.3076 27.6573 54.9662 27.0567 53.5509 27.0167C52.1356 26.9767 50.7624 27.5006 49.7334 28.473L38.5334 38.873M5.33337 43.1663L21.3334 59.1664M50.4 24.4997C50.4 28.7707 46.9377 32.233 42.6667 32.233C38.3957 32.233 34.9334 28.7707 34.9334 24.4997C34.9334 20.2287 38.3957 16.7663 42.6667 16.7663C46.9377 16.7663 50.4 20.2287 50.4 24.4997ZM24 13.833C24 18.2513 20.4183 21.833 16 21.833C11.5818 21.833 8.00004 18.2513 8.00004 13.833C8.00004 9.41473 11.5818 5.83301 16 5.83301C20.4183 5.83301 24 9.41473 24 13.833Z"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default WashingHandIconSVG;
